import { BackButton } from '../../orderManagement/orderDetail/BackButton'
import classes from '../../orderManagement/orderDetail/index.module.scss'

export const NavigateBackButton = () => {
  return (
    <div className={classes.container} style={{ padding: 0 }}>
      <BackButton />
    </div>
  )
}
